import React from 'react';

import {
  STATISTICS_ORDERS as FILTERS_STATISTICS_ORDERS,
} from '../../orders/filters';

import createChartGroup from '../createChartGroup';

import {
  Groups,
  GroupsWrapper,
  GroupsLoading,
} from '../../../components/Statistics';

import {
  filterCompare,
} from '../filters';

const GROUPS = [{
  id: 'countries',
  title: 'Countries',
  maxItems: 10,
  sorts: [
    'default',
    'valueDsc',
    'valueAsc',
  ],
  charts: [{
    id: 'countriesPerOrders',
    label: 'Orders',
    precision: 0,
    title: 'Number of orders per country.',
  }, {
    id: 'countriesPerRevenue',
    label: 'Revenue',
    title: 'Revenue per country.',
  }],
}, {
  id: 'cities',
  title: 'Cities',
  maxItems: 10,
  sorts: [
    'default',
    'valueDsc',
    'valueAsc',
  ],
  charts: [{
    id: 'citiesPerOrders',
    label: 'Orders',
    precision: 0,
    title: 'Number of orders per city.',
  }, {
    id: 'citiesPerRevenue',
    label: 'Revenue',
    title: 'Revenue per city.',
  }],
}].map(group => createChartGroup(group));

export default ['PageStatistics', {
  id: 'statistics-locations',
  title: 'Locations',
  label: 'Locations',
  path: '/analytics/locations',
  loadUrl: '/statistics/locations',
  getUseFiltersExtra: () => true,
  redirect: [['redirect.unauthorized']],
  filters: [
    filterCompare,
    ...FILTERS_STATISTICS_ORDERS.map(a => ([a[0], {
      ...a[1],
      // isExtra: false,
      whereSide: 'where',
    }])),
    ...FILTERS_STATISTICS_ORDERS.map(a => ([a[0], {
      ...a[1],
      id: `b.${a[1].id}`,
      // isExtra: false,
      section: 'topCompare',
      whereSide: 'whereB',
      skip: [
        ...(a[1].skip || []),
        props => !['1', '2'].includes(`${props.searchParams.compare}`),
      ],
    }])),
  ],
  renderStats: (props) => {
    if (!props.data && props.loading) {
      return (
        <GroupsWrapper>
          <GroupsLoading />
        </GroupsWrapper>
      );
    }
    if (!props.data || !props.data.data) {
      return <GroupsWrapper />;
    }
    return (
      <GroupsWrapper loading={props.loading}>
        <Groups {...props} groups={GROUPS} />
      </GroupsWrapper>
    );
  },
}];
